module.exports = __webpack_public_path__ + "static/media/Fogg.ee50559d.png";